/* ==========================================================================
   Koolseed — "Koolseed'ini Bul" testi
   Puanlama tamamen içerikten okunur: her cevabın data-score özniteliği
   "ürün-handle:puan" çiftlerini taşır. Böylece soru ve ürün eklemek
   theme editor'de yapılır, burada kod değişmez.
   ========================================================================== */

(function () {
  'use strict';

  class KsQuiz extends HTMLElement {
    connectedCallback() {
      this.total = Number(this.dataset.total) || 0;
      this.steps = Array.from(this.querySelectorAll('[data-quiz-step]'));
      this.intro = this.querySelector('[data-quiz-intro]');
      this.stepsWrap = this.querySelector('[data-quiz-steps]');
      this.resultWrap = this.querySelector('[data-quiz-result]');
      this.progress = this.querySelector('[data-quiz-progress]');
      this.counter = this.querySelector('[data-quiz-counter]');
      this.cards = Array.from(this.querySelectorAll('[data-quiz-for]'));

      this.index = 0;
      this.scores = {};

      const start = this.querySelector('[data-quiz-start]');
      if (start) start.addEventListener('click', () => this.begin());

      const restart = this.querySelector('[data-quiz-restart]');
      if (restart) restart.addEventListener('click', () => this.reset());

      this.addEventListener('click', (event) => {
        const answer = event.target.closest('[data-quiz-answer]');
        if (answer) { this.choose(answer); return; }
        const back = event.target.closest('[data-quiz-back]');
        if (back) this.go(this.index - 1);
      });
    }

    begin() {
      this.intro.hidden = true;
      this.stepsWrap.hidden = false;
      this.go(0);
      this.stepsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    reset() {
      this.scores = {};
      this.index = 0;
      this.cards.forEach((card) => { card.hidden = true; });
      this.steps.forEach((step) => {
        step.querySelectorAll('[aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      });
      this.resultWrap.hidden = true;
      this.intro.hidden = false;
      this.stepsWrap.hidden = true;
    }

    choose(button) {
      const step = button.closest('[data-quiz-step]');
      step.querySelectorAll('[aria-pressed]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');

      // Önceki seçim varsa puanını geri al — geri gidip değiştirmek serbest.
      const previous = step.dataset.picked;
      if (previous) this.applyScore(previous, -1);
      step.dataset.picked = button.dataset.score || '';
      this.applyScore(step.dataset.picked, 1);

      // Seçimin görüldüğü hissedilsin diye kısa bir gecikme.
      window.setTimeout(() => {
        if (this.index + 1 < this.steps.length) this.go(this.index + 1);
        else this.finish();
      }, 260);
    }

    applyScore(raw, sign) {
      if (!raw) return;
      raw.split(',').forEach((pair) => {
        const [handle, points] = pair.split(':');
        if (!handle) return;
        const key = handle.trim();
        const value = Number(points) || 1;
        this.scores[key] = (this.scores[key] || 0) + value * sign;
      });
    }

    go(index) {
      if (index < 0 || index >= this.steps.length) return;
      this.steps.forEach((step, i) => { step.hidden = i !== index; });
      this.index = index;

      const percent = ((index + 1) / this.steps.length) * 100;
      if (this.progress) this.progress.style.width = `${percent}%`;
      if (this.counter) {
        // "Soru 2/5" — metin çeviriden geliyor, sayılar yerine konuyor.
        // Yer tutucular @current@/@total@ — Liquid süslü parantezleriyle
        // karışmasın diye bilerek farklı.
        const template = (window.KS_STRINGS && window.KS_STRINGS.quizStep) || '@current@/@total@';
        this.counter.textContent = template
          .replace('@current@', index + 1)
          .replace('@total@', this.steps.length);
      }
    }

    finish() {
      const winner = Object.keys(this.scores).sort((a, b) => this.scores[b] - this.scores[a])[0];

      let matched = this.cards.find((card) => card.dataset.quizFor === winner);
      // Eşleşen sonuç kartı yoksa ilk kartı göster; kullanıcı boş ekran görmesin.
      if (!matched) matched = this.cards[0];

      this.cards.forEach((card) => { card.hidden = card !== matched; });
      this.stepsWrap.hidden = true;
      this.resultWrap.hidden = false;
      this.resultWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('ks-quiz')) customElements.define('ks-quiz', KsQuiz);
})();
